import { createI18n } from "vue-i18n";
import en from "./en";
import zh from "./zh";

const messages = {
    en,
    zh,
};
 
const locale = "zh";


// 初始化 i18n 实例
const i18n = createI18n({
   legacy: false, // 使用 Composition API 模式，则需要将其设置为false
   globalInjection: true, // 全局注入 $t 函数
   locale,
   messages,
 });

export default i18n